import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

type SettingsState = {
	gameControlsExpanded: boolean;
	/** @see https://accessibility.build/wcag/2-1-4 WCAG 2.1.4: Character Key Shortcuts */
	gameControlKeys: boolean;
};

const initialState: SettingsState = {
	gameControlsExpanded: true,
	gameControlKeys: true,
};

export const settingsStore = createSlice({
	name: 'settings',
	initialState,
	reducers: {
		toggleGameControlsExpanded: (state) => {
			state.gameControlsExpanded = !state.gameControlsExpanded;
		},
		toggleKeyboardShortcuts: (state) => {
			state.gameControlKeys = !state.gameControlKeys;
		},
		resetSettings: () => {
			return initialState;
		},
	},
	selectors: {
		gameControlsExpanded: (state) => state.gameControlsExpanded,
		gameControlKeysEnabled: (state) => state.gameControlKeys,
	},
});

export const useSettingsSelector = useSelector.withTypes<{ settings: SettingsState; }>();